import {
  BirdSound,
  ForestSound,
  RainSound,
  WaterStreamSound,
  BonFireSound,
  NightSound,
  SubmarineSound,
  ThunderSound,
  WavesSound,
  WindSound,
  PublicPlaceSound,
  PlaneSound,
  TrainSound,
  SeaShoreSound,
  WindOnGrassSound,
} from "../Sounds/index";

const categorySoundCombos = {
    productivity: [
    [ { sound: PublicPlaceSound, volume: 0.3 }, { sound: TrainSound, volume: 0.4 } ],
    [ { sound: PlaneSound, volume: 0.6 }, { sound: SeaShoreSound, volume: 0.4 } ],
    [ { sound: WindSound, volume: 0.6 }, { sound: WaterStreamSound, volume: 0.4 } ],
    [ { sound: TrainSound, volume: 0.6 }, { sound: BirdSound, volume: 0.5 } ],
    [ { sound: SeaShoreSound, volume: 0.4 }, { sound: WindSound, volume: 0.6 } ],
    [ { sound: PublicPlaceSound, volume: 0.4 }, { sound: RainSound, volume: 0.4 } ],
    [ { sound: TrainSound, volume: 0.6}, { sound: PlaneSound, volume: 0.4 }, { sound: WaterStreamSound, volume: 0.6 } ],
    [ { sound: WindSound, volume: 0.3 }, { sound: RainSound, volume: 0.3 }, { sound: BonFireSound, volume: 0.5 } ],
    [ { sound: ForestSound, volume: 0.4}, { sound: BirdSound, volume: 0.3 }, { sound: WindSound, volume: 0.5 } ],
    [ { sound: PlaneSound, volume: 0.5 }, { sound: SubmarineSound, volume: 0.3 } ]
  ],
  random: [
    [ { sound: NightSound, volume: 0.5 }, { sound: ThunderSound, volume: 0.4 } ],
    [ { sound: BirdSound, volume: 0.4 }, { sound: SeaShoreSound, volume: 0.5 } ],
    [ { sound: TrainSound, volume: 0.6 }, { sound: BonFireSound, volume: 0.45 } ],
    [ { sound: PlaneSound, volume: 0.5 }, { sound: ForestSound, volume: 0.4 } ],
    [ { sound: ThunderSound, volume: 0.4 }, { sound: PublicPlaceSound, volume: 0.5 } ],
    [ { sound: SubmarineSound, volume: 0.4 }, { sound: BirdSound, volume: 0.4 }, { sound: WindSound, volume: 0.4 } ],
    [ { sound: BirdSound, volume: 0.5 }, { sound: SeaShoreSound, volume: 0.4 } ],
    [ { sound: PublicPlaceSound, volume: 0.5 }, { sound: BonFireSound, volume: 0.5 } ],
    [ { sound: NightSound, volume: 0.4 }, { sound: RainSound, volume: 0.4 }, { sound: SeaShoreSound, volume: 0.4 } ],
    [ { sound: ThunderSound, volume: 0.4 }, { sound: ForestSound, volume: 0.4 }, { sound: TrainSound, volume: 0.5 } ]
  ],
  relax: [
    [ { sound: BirdSound, volume: 0.5 }, { sound: ForestSound, volume: 0.4 } ],
    [ { sound: RainSound, volume: 0.5 }, { sound: WaterStreamSound, volume: 0.4 } ],
    [ { sound: BonFireSound, volume: 0.4 }, { sound: WindOnGrassSound, volume: 0.4 } ],
    [ { sound: WavesSound, volume: 0.5 }, { sound: WindSound, volume: 0.4 } ],
    [ { sound: SeaShoreSound, volume: 0.4 }, { sound: BirdSound, volume: 0.4 } ],
    [ { sound: RainSound, volume: 0.5 }, { sound: BonFireSound, volume: 0.4 } ],
    [ { sound: WindSound, volume: 0.5 }, { sound: WaterStreamSound, volume: 0.4 } ],
    [ { sound: BirdSound, volume: 0.4 }, { sound: SeaShoreSound, volume: 0.4 }, { sound: WindSound, volume: 0.4 } ],
    [ { sound: ForestSound, volume: 0.4 }, { sound: SeaShoreSound, volume: 0.4 }, { sound: WindSound, volume: 0.4 } ],
    [ { sound: WaterStreamSound, volume: 0.4 }, { sound: WindOnGrassSound, volume: 0.4 } ]
  ],
  coding: [
    [ { sound: RainSound, volume: 0.5 }, { sound: SeaShoreSound, volume: 0.4 } ],
    [ { sound: PlaneSound, volume: 0.5 }, { sound: PublicPlaceSound, volume: 0.4 } ],
    [ { sound: TrainSound, volume: 0.5 }, { sound: SubmarineSound, volume: 0.4 } ],
    [ { sound: BonFireSound, volume: 0.4 }, { sound: WindSound, volume: 0.4 } ],
    [ { sound: WaterStreamSound, volume: 0.4 }, { sound: WindSound, volume: 0.4 } ],
    [ { sound: WindSound, volume: 0.5 }, { sound: BirdSound, volume: 0.4 } ],
    [ { sound: ForestSound, volume: 0.4 }, { sound: RainSound, volume: 0.5 } ],
    [ { sound: SeaShoreSound, volume: 0.4 }, { sound: BonFireSound, volume: 0.4 }, { sound: ThunderSound, volume: 0.4 } ],
    [ { sound: SubmarineSound, volume: 0.4 }, { sound: WindSound, volume: 0.4 }, { sound: RainSound, volume: 0.5 } ],
    [ { sound: PublicPlaceSound, volume: 0.5 }, { sound: WindSound, volume: 0.4 }, { sound: SeaShoreSound, volume: 0.4 } ]
  ],
  sleep: [
    [ { sound: RainSound, volume: 0.5 }, { sound: ThunderSound, volume: 0.3 } ],
    [ { sound: WaterStreamSound, volume: 0.4 }, { sound: WindSound, volume: 0.3 } ],
    [ { sound: BonFireSound, volume: 0.4 }, { sound: RainSound, volume: 0.5 } ],
    [ { sound: ForestSound, volume: 0.4 }, { sound: WindOnGrassSound, volume: 0.4 } ],
    [ { sound: WavesSound, volume: 0.5 }, { sound: SeaShoreSound, volume: 0.4 } ],
    [ { sound: BirdSound, volume: 0.4 }, { sound: RainSound, volume: 0.5 } ],
    [ { sound: WindOnGrassSound, volume: 0.4 }, { sound: SeaShoreSound, volume: 0.4 }, { sound: ThunderSound, volume: 0.3 } ],
    [ { sound: SeaShoreSound, volume: 0.4 }, { sound: BirdSound, volume: 0.4 } ],
    [ { sound: WaterStreamSound, volume: 0.4 }, { sound: ForestSound, volume: 0.4 }, { sound: WindSound, volume: 0.3 } ],
    [ { sound: SeaShoreSound, volume: 0.4 }, { sound: WindSound, volume: 0.3 }, { sound: BonFireSound, volume: 0.4 } ]
  ],
  meditation: [
    [ { sound: ForestSound, volume: 0.4 }, { sound: BirdSound, volume: 0.4 } ],
    [ { sound: WindOnGrassSound, volume: 0.4 }, { sound: RainSound, volume: 0.5 } ],
    [ { sound: BonFireSound, volume: 0.4 }, { sound: WaterStreamSound, volume: 0.4 } ],
    [ { sound: SeaShoreSound, volume: 0.4 }, { sound: BirdSound, volume: 0.4 } ],
    [ { sound: RainSound, volume: 0.5 }, { sound: ForestSound, volume: 0.4 } ],
    [ { sound: WavesSound, volume: 0.5 }, { sound: WindSound, volume: 0.4 } ],
    [ { sound: RainSound, volume: 0.5 }, { sound: WaterStreamSound, volume: 0.4 }, { sound: ForestSound, volume: 0.4 } ],
    [ { sound: BirdSound, volume: 0.4 }, { sound: SeaShoreSound, volume: 0.4 } ],
    [ { sound: WindSound, volume: 0.4 }, { sound: BonFireSound, volume: 0.4 }, { sound: BirdSound, volume: 0.4 } ],
    [ { sound: RainSound, volume: 0.5 }, { sound: ThunderSound, volume: 0.3 } ]
  ],
  focus: [
    [ { sound: RainSound, volume: 0.5 }, { sound: TrainSound, volume: 0.5 } ],
    [ { sound: SeaShoreSound, volume: 0.4 }, { sound: WindSound, volume: 0.4 } ],
    [ { sound: PublicPlaceSound, volume: 0.5 }, { sound: WindSound, volume: 0.4 } ],
    [ { sound: WaterStreamSound, volume: 0.4 }, { sound: BirdSound, volume: 0.4 } ],
    [ { sound: PlaneSound, volume: 0.5 }, { sound: WindSound, volume: 0.4 } ],
    [ { sound: RainSound, volume: 0.5 }, { sound: SeaShoreSound, volume: 0.4 }, { sound: BirdSound, volume: 0.4 } ],
    [ { sound: WindSound, volume: 0.4 }, { sound: ForestSound, volume: 0.4 } ],
    [ { sound: TrainSound, volume: 0.5 }, { sound: RainSound, volume: 0.5 }, { sound: SeaShoreSound, volume: 0.4 } ],
    [ { sound: WindOnGrassSound, volume: 0.4 }, { sound: WaterStreamSound, volume: 0.4 } ],
    [ { sound: RainSound, volume: 0.5 }, { sound: WindSound, volume: 0.4 }, { sound: BonFireSound, volume: 0.4 } ]
  ],
  motivation: [
    [ { sound: ThunderSound, volume: 0.4 }, { sound: RainSound, volume: 0.5 } ],
    [ { sound: TrainSound, volume: 0.5 }, { sound: BonFireSound, volume: 0.4 } ],
    [ { sound: PlaneSound, volume: 0.5 }, { sound: ThunderSound, volume: 0.4 } ],
    [ { sound: SeaShoreSound, volume: 0.4 }, { sound: WindSound, volume: 0.4 } ],
    [ { sound: PublicPlaceSound, volume: 0.5 }, { sound: TrainSound, volume: 0.5 } ],
    [ { sound: ThunderSound, volume: 0.4 }, { sound: BirdSound, volume: 0.4 } ],
    [ { sound: NightSound, volume: 0.4 }, { sound: RainSound, volume: 0.5 }, { sound: BonFireSound, volume: 0.4 } ],
    [ { sound: WindSound, volume: 0.4 }, { sound: ForestSound, volume: 0.4 }, { sound: SeaShoreSound, volume: 0.4 } ],
    [ { sound: BirdSound, volume: 0.4 }, { sound: TrainSound, volume: 0.5 } ],
    [ { sound: SubmarineSound, volume: 0.4 }, { sound: ThunderSound, volume: 0.4 }, { sound: WindSound, volume: 0.4 } ]
  ],
  study: [
    [ { sound: WaterStreamSound, volume: 0.4 }, { sound: RainSound, volume: 0.5 } ],
    [ { sound: TrainSound, volume: 0.5 }, { sound: WindSound, volume: 0.4 } ],
    [ { sound: RainSound, volume: 0.5 }, { sound: WindOnGrassSound, volume: 0.4 } ],
    [ { sound: BonFireSound, volume: 0.4 }, { sound: RainSound, volume: 0.5 } ],
    [ { sound: ForestSound, volume: 0.4 }, { sound: SeaShoreSound, volume: 0.4 } ],
    [ { sound: PlaneSound, volume: 0.5 }, { sound: RainSound, volume: 0.5 } ],
    [ { sound: WindSound, volume: 0.4 }, { sound: BirdSound, volume: 0.4 } ],
    [ { sound: RainSound, volume: 0.5 }, { sound: TrainSound, volume: 0.5 }, { sound: SeaShoreSound, volume: 0.4 } ],
    [ { sound: WaterStreamSound, volume: 0.4 }, { sound: WindSound, volume: 0.4 }, { sound: ForestSound, volume: 0.4 } ],
    [ { sound: BonFireSound, volume: 0.4 }, { sound: RainSound, volume: 0.5 }, { sound: BirdSound, volume: 0.4 } ]
  ]
};

export default categorySoundCombos;
